.SDSCheckbox {
  display: inline-flex;
  align-items: center;
  gap: var(--gaps-text-medium);
  position: relative;
  cursor: pointer;

  &__root {
    padding: 0;
    cursor: inherit;
    border-radius: var(--border-radius-button-small);
    display: flex;
    justify-content: center;
    align-items: center;
    width: var(--size-input);
    height: var(--size-input);
    background: var(--background-fill);
    flex-shrink: 0;
    transition: all 0.2s ease-in-out;

    fill: var(--text-on-brand);
    stroke-width: 1px;
    stroke: var(--input-disabled);
    filter: drop-shadow(0 1px 3px rgba(31, 47, 84, 0.1));

    &:hover {
      border-color: var(--input-hover);
    }

    &:focus {
      border-color: var(--input-pressed);
    }
  }

  &__indicator {
    display: flex;
    justify-content: center;
    align-items: center;

    .SDSCheckbox__icon {
      svg {
        width: 12px;
        height: 12px;
        color: var(--text-on-brand);
        transition: opacity 0.2s ease-in-out;
      }
    }
  }

  // Error state
  &--error {
    .SDSCheckbox__root {
      border-color: var(--status-alert);

      &:hover,
      &:focus {
        border-color: var(--status-alert);
      }
    }

    &.SDSCheckbox--checked .SDSCheckbox__root {
      background: var(--status-alert);
      border-color: var(--status-alert);

      &:hover,
      &:focus {
        border-color: var(--status-alert);
        background-color: var(--status-alert);
      }
    }
  }

  // Disabled states
  &--disabled {
    cursor: default;

    .SDSCheckbox__root {
      border-color: var(--input-disabled);
      background: var(--background-fill);

      &:hover,
      &:focus {
        border-color: var(--input-disabled);
      }
    }

    // Disabled subcheck state
    &.SDSCheckbox--subcheck .SDSCheckbox__root {
      background: var(--brand-quaternary);
      border-color: var(--brand-quaternary);

      .SDSCheckbox__icon svg {
        color: var(--brand-quaternary);
      }
    }

    // Disabled checked state
    &.SDSCheckbox--checked .SDSCheckbox__root {
      background: var(--background-sidebar-hover);
      border-color: var(--background-sidebar-hover);

      &:hover,
      &:focus,
      &:active {
        background: var(--background-sidebar-hover);
        border-color: var(--background-sidebar-hover);
      }
    }
  }
}

// SDSCheckboxGroup styles
.SDSCheckboxGroup {
  display: flex;
  flex-direction: column;
  gap: var(--gaps-text-small, 8px);

  &--disabled {
    opacity: 0.6;
    pointer-events: none;
  }
}

.SDSCheckbox--checked .SDSCheckbox__root {
  background-color: var(--brand-primary);
  border-color: var(--brand-primary);

  &:hover {
    background-color: var(--brand-secondary);
    border-color: var(--brand-secondary);
  }

  &:focus {
    background: var(--brand-tertiary);
  }
}
